import { useState, useEffect } from 'react';
import { isKavakSubdomain } from 'utils/general';
import { CommissionSliderContainer, SliderContent } from './style';
import { getCommissionSliderConfig } from '../commission';

const ComissionSlider = ({
  setPercentCommission,
  grievance_percent,
  min_grievance_percent,
  max_grievance_percent,
  percentCommission,
  useRangeSlider,
}) => {
  const sliderConfig = getCommissionSliderConfig({
    grievancePercent: grievance_percent,
    minGrievancePercent: min_grievance_percent,
    maxGrievancePercent: max_grievance_percent,
    percentCommission,
    useAbsoluteCommission: useRangeSlider,
  });
  const [percentCommissionLocal, setPercentCommissionLocal] = useState(sliderConfig.value);
  const commissionLabel = isKavakSubdomain() ? 'Percentual de agravo' : 'Percentual de comissionamento';

  useEffect(() => {
    setPercentCommissionLocal(sliderConfig.value);
  }, [sliderConfig.value]);

  return (
    <CommissionSliderContainer style={{ padding: 30 }}>
      {sliderConfig.shouldShow && sliderConfig.isFixed && (
        <p aria-label={`${commissionLabel} fixo`}>
          {commissionLabel}: {sliderConfig.value}%
        </p>
      )}
      {sliderConfig.shouldShow && !sliderConfig.isFixed && (
        <>
          <p>{commissionLabel}</p>
          <SliderContent
            track={false}
            aria-labelledby="track-false-slider"
            valueLabelDisplay="auto"
            valueLabelFormat={(e) => {
              if (useRangeSlider) return `${e}%`;

              return `${Math.round((percentCommissionLocal * Number(grievance_percent || 0)) / 100)}%`;
            }}
            getAriaValueText={(value) => `${value}`}
            value={percentCommissionLocal}
            onChange={(event, value) => {
              setPercentCommissionLocal(value);
            }}
            onChangeCommitted={(event, value) => {
              setPercentCommission(value);
            }}
            min={sliderConfig.min}
            max={sliderConfig.max}
            step={sliderConfig.step}
            marks={sliderConfig.marks}
          />
        </>
      )}
    </CommissionSliderContainer>
  );
};

export default ComissionSlider;
